export const IMAGE_SIZE = 32;
export const GAP = 8;
export const ITEM_WIDTH = IMAGE_SIZE + GAP;
